import React, {useEffect, useState} from 'react';

import { readFile } from './utils';
function TickerList({recommendation, tickers}) {
    return (
        <div style={{marginLeft: '2%', width: '90%'}}>
            <h3>{recommendation}</h3>
            {tickers.map(ticker => (
                <div>{ticker}</div>
            ))}
        </div>
    );
}

const AIRecommendationComponent = () => {
    const [strongBuyList, setStrongBuyList] = useState([]);
    const [buyList, setBuyList] = useState([]);
    const [holdList, setHoldList] = useState([]);
    const [sellList, setSellList] = useState([]);
    const [strongSellList, setStrongSellList] = useState([]);



    useEffect(() => {
        // for local test. It will read data from public/data/ai_agent/
        // const today_str = "2025-09-01";
        const formatter = new Intl.DateTimeFormat("en-CA", {
            timeZone: "America/New_York",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
        const today_str = formatter.format(new Date());
        console.log(today_str);
        // const today_str = new Date().toISOString().split("T")[0];
        const dir =  `/data/ai_agent/${today_str}`;
        const input_prefix = "nasdaq_100";
        const strong_buy_filename = `${dir}/${input_prefix}_strong_buy_list_${today_str}.txt`;
        const buy_filename = `${dir}/${input_prefix}_buy_list_${today_str}.txt`;
        const strong_sell_filename = `${dir}/${input_prefix}_strong_sell_list_${today_str}.txt`;
        const sell_filename = `${dir}/${input_prefix}_sell_list_${today_str}.txt`;
        const hold_filename = `${dir}/${input_prefix}_hold_list_${today_str}.txt`;

        const loadFiles = async () => {
            try {
                const strongBuy = await readFile(strong_buy_filename);
                const buy = await readFile(buy_filename);
                const hold = await readFile(hold_filename);
                const sell = await readFile(sell_filename);
                const strongSell = await readFile(strong_sell_filename);
    
                setStrongBuyList(strongBuy);
                setBuyList(buy);
                setHoldList(hold);
                setSellList(sell);
                setStrongSellList(strongSell);
            } catch (err) {
                console.error("error loading files.", err);
            }

        };

        loadFiles();
    }, []);




    return (
         <React.Fragment>
            <h1 className="text-2xl font-bold mb-6 text-gray-800">AI Recommendation Nasdaq 100 Index</h1>

            <TickerList recommendation="Strong Buy" tickers={strongBuyList} />
            <TickerList recommendation="Buy" tickers={buyList} />
            <TickerList recommendation="Hold" tickers={holdList} />
            <TickerList recommendation="Sell" tickers={sellList} />
            <TickerList recommendation="Strong Sell" tickers={strongSellList} />
         </React.Fragment>
    );
};

export default AIRecommendationComponent;